import React from 'react';
import { Icon, IconComponent } from './icon';
import src from 'grpn-mx-mixer/dist/images/icons/arrow-left.svg';

export const IconArrowLeft: IconComponent = props => <Icon {...props} src={src} />;
